'use client';
import { useEffect, useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { clsx } from 'clsx';
import { StructureImages } from '@/components/pages/about/StructurePage/StructureImages/StructureImages';
import { ActionButton } from '@/components/ui/ActionButton/ActionButton';
import { SvgArrowLeft } from '@/components/icons';
import DefaultImg from '@/assets/icons/defaulte_services.svg';
import { API_STATIC_FILES } from '@/utils/constants';
import { MedicalDepartment } from '@/api/medicalDepartments/medicalDepartments.types';
import s from './Structure.module.scss';
import { replaceNewLines } from '@/utils/strings';

interface Props {
  departments: MedicalDepartment[];
}

export const Structure = ({ departments }: Props) => {
  const [activeDepartment, setActiveDepartment] = useState<MedicalDepartment>(departments[0]);
  const [mediafiles, setMediafiles] = useState<string[]>([]);

  useEffect(() => {
    const mediafiles: string[] = [];
    for (let i = 1; i <= 6; i++) {
      const img = activeDepartment[`mediafile${i}` as keyof MedicalDepartment] as string | null | undefined;
      if (img) {
        mediafiles.push(`${API_STATIC_FILES}${img}`);
      }
    }
    setMediafiles(mediafiles);
  }, [activeDepartment]);

  return (
    <div className={s.structure}>
      <div className={s.structure__track}>
        <ul className={s.structure__list}>
          {departments.map((department) => {
            const icon = `${API_STATIC_FILES}${department.department_icon}`;
            return (
              <li
                key={department.id}
                className={clsx(s.structure__item, { [s.structure__item_active]: activeDepartment.id === department.id })}
                onClick={() => setActiveDepartment(department)}
              >
                {department.department_icon
                  ? <Image src={icon} alt={'Иконка отдела'} width={34} height={48} />
                  : <DefaultImg />
                }
                <span>{department.name}</span>
              </li>
            );
          })}
        </ul>
      </div>

      <div className={s.structure__content}>
        <div className={s.structure__head}>
          <h3>{activeDepartment.name}</h3>
          <Link href={'/services'}>
            <ActionButton className={s.structure__button} isLine isDivElement>
              Перейти на услуги <SvgArrowLeft />
            </ActionButton>
          </Link>
        </div>
        <div className={s.structure__text} dangerouslySetInnerHTML={{ __html: replaceNewLines(activeDepartment.description) }} />
        <StructureImages images={mediafiles} />
        <div className={s.structure__hintWrapper}>
          <p className={s.structure__hint}>
            Подробнее со всеми услугами и их ценами можно ознакомиться на странице услуг, нажав на кнопку или же выбрав
            из главного меню
          </p>
          <Link href={'/services'}>
            <ActionButton className={s.structure__button} isLine isDivElement>
              Перейти на услуги <SvgArrowLeft />
            </ActionButton>
          </Link>
        </div>
      </div>
    </div>
  );
};